import React, { FC } from 'react';
import Link from 'next/link';
import { getArticlePageUrl } from 'src/services/pagesUrl/getArticlePageUrl';
import cx from 'classnames';
import Typo from '../Typography/Typo';
import { getMultilineEllipsisStyle } from '../PromptCard/utils/getMultilineEllipsisStyle';
import { TCloudinaryImageShape } from '../CloudinaryResponsiveImage/types';
import { ArticleParentQuoteInfoRemoved } from './ArticleParentQuoteInfoRemoved';
import { ArticleParentInfoDetails } from './ArticleParentInfoDetails';
import { removeHtmlTags } from '../../../utils/removeHtmlTags';

type TArticleParentQuoteInfoProps = {
  parentTitle: string;
  shortDescription: string;
  slug: string;
  parentAuthor: string;
  image?: TCloudinaryImageShape | undefined;
  deactivated?: boolean;
};

export const ArticleParentQuoteInfo: FC<TArticleParentQuoteInfoProps> = ({
  parentTitle,
  shortDescription,
  slug,
  image,
  parentAuthor,
  deactivated,
}) => {
  const isParentInfo = parentAuthor && parentTitle;

  return (
    <Link href={getArticlePageUrl(slug)} target="_blank" rel="noreferrer">
      <div className="p-4 hover:bg-t2-neutral-grey03 rounded-b-[7px]">
        <div
          className={cx('pl-4 border-l-[1px]', {
            'border-l-t2-primary-brandColor': isParentInfo && !deactivated,
            'border-l-t2-neutral-grey08 text-t2-neutral-grey05': !isParentInfo || deactivated,
          })}
        >
          <Typo
            variant="small-p"
            className="pl-[6px] md:mr-6 relative !text-base multiline-ellipsis"
            style={getMultilineEllipsisStyle(2)}
          >
            {removeHtmlTags(shortDescription)}
          </Typo>
          <ArticleParentInfoDetails
            parentAuthor={parentAuthor}
            parentTitle={parentTitle}
            image={image}
            deactivated={deactivated}
          />
        </div>
        {(!isParentInfo || deactivated) && <ArticleParentQuoteInfoRemoved />}
      </div>
    </Link>
  );
};
